import request from '@/utils/request'
import { apiUrl } from '@/config/parameters'
export default {
  //测试加密数据

  savePendingAudit: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/business/savePendingAudit`,
      params,
    )
  },
  //获取权限信息
  getPermission: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getPermission`, {
      params: params,
    })
  },
  //获取案件
  getCaseList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getCaseList`, {
      params: params,
    })
  },
  //添加保存案件
  saveCase: (params = {}) => {
    return request.post(`${apiUrl.FAZX_SEVICEURL}api/backend/saveCase`, params)
  },
  //获取案件类型
  getCaseType: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/case/getCaseType`, {
      params: params,
    })
  },
  //获取审判程序
  getTrialType: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/case/getTrialType`, {
      params: params,
    })
  },
  //获取地区
  getArea: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/common/getArea`, {
      params: params,
    })
  },
  getLawyerCategory: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getLawyerCategory`,
      {
        params: params,
      },
    )
  },
  //获取律师类型
  getAdeptCategory: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getAdeptCategory`, {
      params: params,
    })
  },
  //获取律师状态
  getLawyerStatus: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getLawyerStatus`, {
      params: params,
    })
  },
  //获取律师列表
  getLawyerList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getLawyerList`, {
      params: params,
    })
  },
  //审核律师
  auditLawyer: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/auditLawyer`,
      params,
    )
  },
  //设置推荐律师
  recommendLawyer: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/recommendLawyer`,
      params,
    )
  },
  //获取地区列表
  getAllArea: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/common/getAllArea`, {
      params: params,
    })
  },
  //添加修改律师
  saveLawyer: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveLawyer`,
      params,
    )
  },

  //获取会员等级
  getMembership: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/membership/getMembership`, {
      params: params,
    })
  },
  //获取用户列表
  getUserList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getUserList`, {
      params: params,
    })
  },

  //获取委托类型
  getCategory: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/consult/getCategory`, {
      params: params,
    })
  }, //获取涉嫌金额
  getInvolvedAmount: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/consult/getInvolvedAmount`,
      {
        params: params,
      },
    )
  },
  //获取委托列表
  getConsultList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getConsultList`, {
      params: params,
    })
  },
  //更改委托状态
  updateConsultStatus: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/updateConsultStatus`,
      params,
    )
  },
  //获取咨询列表
  getQucikConsultList: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getQucikConsultList`,
      {
        params: params,
      },
    )
  },
  //选择分配律师
  saveAllocation: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveAllocation`,
      params,
    )
  },
  // 查看分配
  getAllocationList: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getAllocationList`,
      {
        params: params,
      },
    )
  },
  //获取合同文书列表
  getDocumentList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getDocumentList`, {
      params: params,
    })
  },
  //获取文书类型
  getDocumentCategory: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getDocumentCategory`,
      {
        params: params,
      },
    )
  },
  //获取委托看板
  getConsultBoard: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getConsultBoard`, {
      params: params,
    })
  },
  //查看委托评价
  getEvaluate: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getEvaluate`, {
      params: params,
    })
  },
  // 用户看板
  getUserBoard: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getUserBoard`, {
      params: params,
    })
  },
  //咨询看板
  getQucikConsultBoard: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getQucikConsultBoard`,
      {
        params: params,
      },
    )
  },
  //文书看板
  getDocumentBoard: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getDocumentBoard`, {
      params: params,
    })
  },
  //获取服务列表
  getSSTList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getSSTList`, {
      params: params,
    })
  },
  //修改服务列表
  saveSST: (params = {}) => {
    return request.post(`${apiUrl.FAZX_SEVICEURL}api/backend/saveSST`, params)
  },
  //获取擅长类型
  // getAdeptCategory: (params = {}) => {
  //   return request.get(`${apiUrl.FAZX_SEVICEURL}api/lawyer/getAdeptCategory`, {
  //     params: params,
  //   })
  // },
  //获取绑定律师
  getLawyerByUser: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getLawyerByUser`, {
      params: params,
    })
  },
  //保存律师
  saveLawyer: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveLawyer`,
      params,
    )
  },
  //上传图片
  uploadImage: (params = {}) => {
    return request.post(`${apiUrl.FAZX_SEVICEURL}api/base/uploadImage`, params)
  },
  //获取合同类别
  getContractCategory: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getContractCategory`,
      {
        params: params,
      },
    )
  },
  // 保存添加类别
  saveContractCategory: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveContractCategory`,
      params,
    )
  },
  // 、、获取行业类别
  getContractIndustry: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getContractIndustry`,
      {
        params: params,
      },
    )
  },
  // 保存添加行业
  saveContractIndustry: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveContractIndustry`,
      params,
    )
  },
  //获取合同列表
  getContractList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getContractList`, {
      params: params,
    })
  },
  //保存编辑合同saveContract
  saveContract: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveContract`,
      params,
    )
  },
  //获取合同标签
  getContractTag: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getContractTag`, {
      params: params,
    })
  },
  //审核合同
  auditContract: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/auditContract`,
      params,
    )
  },
  //获取协议类型
  getAgreementCategory: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getAgreementCategory`,
      {
        params: params,
      },
    )
  },
  //获取协议
  getAgreementList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getAgreementList`, {
      params: params,
    })
  },
  //保存添加协议
  saveAgreement: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveAgreement`,
      params,
    )
  },
  //律师服务委托看板
  getLawyerBoard: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getLawyerBoard`, {
      params: params,
    })
  },
  // 标签列表
  getContractTagList: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getContractTagList`,
      {
        params: params,
      },
    )
  },
  // 添加标签
  saveContractTag: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveContractTag`,
      params,
    )
  },
  //获取反馈列表
  getOpinionList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getOpinionList`, {
      params: params,
    })
  },
  //查看个人解锁记录
  getLockingBusiness: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getLockingBusiness`,
      {
        params: params,
      },
    )
  },
  //商机投诉列表
  getComplaintBusiness: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getComplaintBusiness`,
      {
        params: params,
      },
    )
  },
  //商机解锁次数
  getOpintsList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getOpintsList`, {
      params: params,
    })
  },
  //c充值次数
  addUnlockNum: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/addUnlockNum`,
      params,
    )
  },
  //解锁统计面板
  getLockingBoard: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getLockingBoard`, {
      params: params,
    })
  },
  //投诉统计面板
  getComplaintBoard: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getComplaintBoard`,
      {
        params: params,
      },
    )
  },
  //删除合同
  delContract: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/delContract`,
      params,
    )
  },
  //获取起诉状生成列表
  getIndictmentList: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getIndictmentList`,
      {
        params: params,
      },
    )
  },
  //开通VIP会员
  setUserMembership: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/setUserMembership`,
      params,
    )
  },
  //获取token
  getSignData: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/wechat/getSignData`, {
      params: params,
    })
  },
  //报价列表
  getQuotationList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getQuotationList`, {
      params: params,
    })
  },
  //报价状态
  getQuotationState: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/common/getQuotationState`, {
      params: params,
    })
  },
  //留言列表
  getCommentList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getCommentList`, {
      params: params,
    })
  },
  //查看材料
  getConsultSupplement: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getConsultSupplement`,
      {
        params: params,
      },
    )
  },
  //添加材料
  addConsultSupplement: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/addConsultSupplement`,
      params,
    )
  },
  //上传图片
  uploadBase: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/consult/uploadBase`,
      params,
    )
  },
  //上传文件
  saveFile: (params = {}) => {
    return request.post(`${apiUrl.FAZX_SEVICEURL}api/consult/saveFile`, params)
  },
  //企业管理
  getCompanyList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getCompanyList`, {
      params: params,
    })
  },
  //获取企业状态
  getCompanyStatus: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/common/getCompanyStatus`, {
      params: params,
    })
  },
  // 企业审核
  auditCompany: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/auditCompany`,
      params,
    )
  },

  //获取提现记录
  getWithdrawalList: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getWithdrawalList`,
      {
        params: params,
      },
    )
  },
  //获取提现状态
  getWithdrawalState: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/common/getWithdrawalState`,
      {
        params: params,
      },
    )
  },
  // 提现审核
  auditWithdrawal: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/auditWithdrawal`,
      params,
    )
  },
  // 收支记录
  getFinancialList: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/backend/getFinancialList`, {
      params: params,
    })
  },
  // 角色
  getRoleType: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/common/getRoleType`, {
      params: params,
    })
  },
  // 收支
  getInorExType: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/financial/getInorExType`, {
      params: params,
    })
  },
  // 支付状态
  getTradeState: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/financial/getTradeState`, {
      params: params,
    })
  },
  // 委托报表
  getConsultingReport: (params = {}) => {
    return request.get(
      `${apiUrl.FAZX_SEVICEURL}api/backend/getConsultingReport`,
      {
        params: params,
      },
    )
  },
  // 委托类型
  getType: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/consult/getType`, {
      params: params,
    })
  },
  // 文章类型
  categories: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/article/categories`, {
      params: params,
    })
  },
  // 标签
  tags: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/article/tags`, {
      params: params,
    })
  },
  // 文章列表
  list: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/article/list`, {
      params: params,
    })
  },
  // 详情
  detail: (params = {}) => {
    return request.get(`${apiUrl.FAZX_SEVICEURL}api/article/detail`, {
      params: params,
    })
  },
   // 审核
  auditArticle: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/auditArticle`,
      params,
    )
  },
  // 添加/修改
  saveArticle: (params = {}) => {
    return request.post(
      `${apiUrl.FAZX_SEVICEURL}api/backend/saveArticle`,
      params,
    )
  },
  // -----------------------------判断是否为电商登录---------------------------------
  // 同步模板
  // jsfunclueFn: window.jsfunclue.getLoginUser((res) => {
  //   return res
  // }),
  // ....................................全局方法...........................
}
